<div>
  <app-loading-overlay-full *ngIf="loading"></app-loading-overlay-full>
  <a (click)="activeModal.close()" class="rounded-4 bg-danger text-white icon-btn modal-close-icon">
    <i class="fs-4 bi bi-x fw-bold"></i>
  </a>
  <div class="w-100">
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="form" class="p-4">
          <h3 class="fw-bold mb-3 pb-2 fs-6">
            Member OTP Verification
          </h3>
          <hr *ngIf="otpHasBeenRequested" class="mb-2">
          <div *ngIf="otpHasBeenRequested" class="row">
            <div class="col-lg-12">
              <div class="input-group flex-nowrap">
                <span appDisableElement [isDisabled]="!otpHasBeenRequested" class="input-group-text"><i
                    class="bi bi-hash"></i> </span>
                <input appDisableElement [isDisabled]="!otpHasBeenRequested" type="number" name="one_time_password"
                  formControlName="one_time_password" class="form-control form-control-lg"
                  placeholder="Enter one-time password" />
              </div>
              <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'one_time_password'">
              </app-validation-message>
            </div>
          </div>
          <hr class="mb-2">
          <div class="row d-flex align-items-center">
            <div class="d-flex justify-content-end">
              <button *ngIf="countDown>0" disabled class="btn btn-lg bg-white me-2">
                <span>Request OTP Resend in {{ countDown }}</span>
              </button>
              <button *ngIf="countDown==0" (click)="requestOneTimePassword()"
                class="btn btn-lg {{ otpHasBeenRequested ? 'btn-light me-2' : 'btn-dark w-100 justify-content-center' }}">
                <span><i
                    class="bi bi-{{ otpHasBeenRequested ? 'arrow-clockwise' : '123' }} fw-bold me-2"></i>
                  {{ otpHasBeenRequested ? 'Resend Member OTP' : 'Request Member OTP' }}</span>
              </button>
              <button *ngIf="otpHasBeenRequested" (click)="verifyOneTimePassword()" class="btn btn-lg btn-primary">
                <i class="bi bi-check2-all fw-semibold me-2"></i> Verify Member OTP
              </button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
